// extracted by mini-css-extract-plugin
export default {"pageControl":"PageControl_pageControl__Dhrfq"};